import { Tab, Tabs } from '@cast/design-system';
import { CpuType, K8sProvider } from '@cast/shared-types';

import { useNormalizedCostsControls } from '../_hooks/useNormalizedCostControls';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const NormalizedCostSectionControls = () => {
  const { cluster } = useCluster();
  const { activeTab, changeActiveTab } = useNormalizedCostsControls();

  const tabs = [
    <Tab key="normalized" label="Normalized" value={CpuType.NORMALIZED} />,
  ];

  if (cluster.providerType !== K8sProvider.ANYWHERE) {
    tabs.push(
      ...[
        <Tab key="on-demand" label="On-demand" value={CpuType.ON_DEMAND} />,
        <Tab key="fallback" label="Fallback" value={CpuType.FALLBACK} />,
        <Tab key="spot" label="Spot" value={CpuType.SPOT} />,
      ]
    );
  }

  return (
    <Tabs
      value={
        cluster.providerType !== K8sProvider.ANYWHERE
          ? activeTab
          : CpuType.NORMALIZED
      }
      sx={{ width: '100%' }}
      onChange={(_, tab) => changeActiveTab(tab)}
      size="small"
      testId="resource-offering-tabs"
    >
      {tabs}
    </Tabs>
  );
};
